import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import AuthService from '../../services/auth.service';
import { CouchSyncService } from '../../services/couch-sync.service';

@Component({
  selector: 'app-login-success',
  imports: [],
  template: '',
})
export class LoginSuccessComponent {
  private auth = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private couchSync = inject(CouchSyncService);
  ngOnInit() {
    if (this.couchSync['globalLoadingSubject']) {
      this.couchSync['globalLoadingSubject'].next(true);
    }
    this.route.queryParamMap.subscribe((params) => {
      const token = params.get('token');

      if (token)
        this.auth.fetchMe(token).subscribe({
          next: (res) => {
            this.auth.setUser({
              email: res.email,
              uuid: res.uuid,
              token: token,
              sectors: res.sectorsDbNames,
              name: res.name,
            });

            this.couchSync.startFullSync(
              { sectors: res.sectorsDbNames, username: res.email, uuid: res.uuid },
              token,
            );

            this.router.navigate(['']);
          },
          error: console.log,
        });
    });
  }
}
